import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { updateBus,updatePendingBus, getAllCategory, getSeatLayoutsByBustype, getAllBusownerAdminRoutes, getRouteById } from '../../Services/Operations/ProductAPI';
import '../../Styles/BusManagementModal.css';

const PlatformFeeConfig = ({ platformFee, onChange }) => {
  return (
    <div className="section-card" style={{ marginBottom: '20px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '15px' }}>
      <h4 className="card-title" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span className="title-icon" style={{ fontSize: '20px' }}>💰</span>
        Platform Fee Configuration
      </h4>

      <div className="platform-fee-container">
        <div className="form-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
          <div className="form-group">
            <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>Fee Type</label>
            <select
              value={platformFee.type}
              onChange={(e) => onChange({ ...platformFee, type: e.target.value })}
              className="modern-select"
              style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            >
              <option value="fixed">Fixed Amount (₹)</option>
              <option value="percentage">Percentage (%)</option>
            </select>
            <small className="helper-text" style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
              {platformFee.type === 'fixed'
                ? 'Charge a fixed amount per booking'
                : 'Charge a percentage of the fare'}
            </small>
          </div>

          <div className="form-group">
            <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>
              {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
            </label>
            <input
              type="number"
              min="0"
              step={platformFee.type === 'fixed' ? "1" : "0.1"}
              value={platformFee.value === 0 ? '' : platformFee.value}
              onChange={(e) => {
                const rawValue = e.target.value;
                const value = rawValue === '' ? 0 : parseFloat(rawValue);
                onChange({ ...platformFee, value: isNaN(value) ? 0 : value });
              }}
              className="modern-input"
              placeholder="0"
              style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            />
          </div>

          <div className="form-group">
            <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>Applicable On</label>
            <select
              value={platformFee.applicableOn}
              onChange={(e) => onChange({ ...platformFee, applicableOn: e.target.value })}
              className="modern-select"
              style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            >
              <option value="per_ticket">Per Ticket</option>
              <option value="per_person">Per Person</option>
            </select>
          </div>
        </div>

        {platformFee.value > 0 && (
          <div className="fee-preview" style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f0f9ff', borderRadius: '4px' }}>
            <div className="preview-title" style={{ fontWeight: '500', marginBottom: '5px' }}>Fee Calculation Preview:</div>
            <div className="preview-details">
              <span>
                {platformFee.type === 'fixed'
                  ? `₹${platformFee.value} per ticket`
                  : `${platformFee.value}% of fare per ticket`}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const EditBusModal = ({ bus, ownerId, onClose, onUpdate,isPending = false }) => {
  console.log("bus received in EditBusModal:", bus);
  const { token } = useSelector(state => state.user);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('basic');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
  const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
  const [blockedSeats, setBlockedSeats] = useState([]);
  
  const [seatModes, setSeatModes] = useState({});
  const [sleeperPairs, setSleeperPairs] = useState({});

  const [platformFee, setPlatformFee] = useState({
    type: 'fixed',
    value: 0,
    applicableOn: 'per_ticket'
  });

  const [ticketBookingType, setTicketBookingType] = useState({
    instantTicket: false,
    seatBooking: false,
    both: false
  });

  const [cancellationTime, setCancellationTime] = useState({ hours: 1, minutes: 0 });

  const [bookingClosedBefore, setBookingClosedBefore] = useState({ hours: 1, minutes: 0 });

  const [form, setForm] = useState({
    busNumber: '',
    busName: '',
    busType: 'AC',
    busCategory: 'Seater',
    amenities: []
  });

  const [tripType, setTripType] = useState('oneWay');
  const [activeMatrixTab, setActiveMatrixTab] = useState('up');

  const [sourceCity, setSourceCity] = useState('');
  const [destinationCity, setDestinationCity] = useState('');
  const [availableRoutes, setAvailableRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [loadingRoutes, setLoadingRoutes] = useState(false);
  const [showRouteDropdown, setShowRouteDropdown] = useState(false);
  const [routeSearchTerm, setRouteSearchTerm] = useState('');

  const [layoutTemplates, setLayoutTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [activeSeats, setActiveSeats] = useState([]);
  const [customSeatLabels, setCustomSeatLabels] = useState({});
  const [showLayoutModal, setShowLayoutModal] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [loadingLayouts, setLoadingLayouts] = useState(false);
  const [editingSeat, setEditingSeat] = useState(null);
  const [tempSeatLabel, setTempSeatLabel] = useState('');

  const [existingImages, setExistingImages] = useState([]);
  const [existingVideo, setExistingVideo] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [pricing, setPricing] = useState({
    basePrice: '',
    baseDistance: '',
    costPerKm: ''
  });

  const [fareMatrixUp, setFareMatrixUp] = useState([]);
  const [fareMatrixDown, setFareMatrixDown] = useState([]);

  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  const [operatingDays, setOperatingDays] = useState([
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
  ]);

  const [reconstructedRouteUp, setReconstructedRouteUp] = useState(null);
  const [reconstructedRouteDown, setReconstructedRouteDown] = useState(null);

  const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
  const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
  const AMENITIES_LIST = [
    'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
    'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
    'GPS Tracking', 'SOS Switch'
  ];
  const DAYS_OF_WEEK = [
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
  ];

  const getSideCounts = () => {
    let leftCount = 2, rightCount = 2;
    try {
      if (selectedTemplate?.configuration?.includes('*')) {
        const parts = selectedTemplate.configuration.split('*');
        leftCount = parseInt(parts[0]) || 2;
        rightCount = parseInt(parts[1]) || 2;
      }
    } catch (e) { leftCount = 2; rightCount = 2; }
    return { leftCount, rightCount };
  };

  const isSleeperEligible = () => {
    if (form.busCategory !== 'Seater+Sleeper') return false;
    const { leftCount, rightCount } = getSideCounts();
    return leftCount >= 2 || rightCount >= 2;
  };

  const getSeatSide = (seat) => {
    const { leftCount } = getSideCounts();
    return (seat.column || 0) <= leftCount ? 'left' : 'right';
  };

  const findSleeperPartner = (seat) => {
    if (!selectedTemplate) return null;
    const side = getSeatSide(seat);
    const consumed = new Set(Object.values(sleeperPairs));
    const sameRow = selectedTemplate.seats.filter(
      s => s.row === seat.row && getSeatSide(s) === side
    );

    const isUsable = (s) =>
      s.seatNumber !== seat.seatNumber &&
      !consumed.has(s.seatNumber) &&
      !seatModes[s.seatNumber] &&
      !blockedSeats.includes(s.seatNumber);

    const next = sameRow.find(s => s.column === (seat.column || 0) + 1);
    if (next && isUsable(next)) return next;

    const prev = sameRow.find(s => s.column === (seat.column || 0) - 1);
    if (prev && isUsable(prev)) return prev;

    return null;
  };

  const handleToggleSleeper = (seatObj) => {
    const isCurrentlySleeper = seatModes[seatObj.seatNumber] === 'sleeper';

    if (isCurrentlySleeper) {
      const partnerSeatNumber = sleeperPairs[seatObj.seatNumber];
      setSeatModes(prev => { const n = { ...prev }; delete n[seatObj.seatNumber]; return n; });
      setSleeperPairs(prev => { const n = { ...prev }; delete n[seatObj.seatNumber]; return n; });
      if (partnerSeatNumber) {
        setActiveSeats(prev => prev.filter(s => s !== partnerSeatNumber));
      }
    } else {
      const partner = findSleeperPartner(seatObj);
      if (!partner) {
        toast.error('No adjacent seat available to merge into a sleeper on this side.');
        return;
      }
      setSeatModes(prev => ({ ...prev, [seatObj.seatNumber]: 'sleeper' }));
      setSleeperPairs(prev => ({ ...prev, [seatObj.seatNumber]: partner.seatNumber }));
      if (!activeSeats.includes(seatObj.seatNumber)) {
        setActiveSeats(prev => [...prev, seatObj.seatNumber]);
      }
      if (!activeSeats.includes(partner.seatNumber)) {
        setActiveSeats(prev => [...prev, partner.seatNumber]);
      }
    }
  };
const syncSeatsWithTemplate = (template, existingActiveSeats, existingBlockedSeats, existingLabels, existingSleeperPairs, existingSeatModes) => {
  if (!template || !template.seats) return null;

  const templateSeatNumbers = template.seats.map(s => s.seatNumber);

  const validActiveSeats = existingActiveSeats.filter(s => templateSeatNumbers.includes(s));
  const validBlockedSeats = existingBlockedSeats.filter(s => templateSeatNumbers.includes(s));

  const validSleeperPairs = {};
  const validSeatModes = {};
  
  Object.entries(existingSleeperPairs || {}).forEach(([primary, partner]) => {
    if (templateSeatNumbers.includes(primary) && templateSeatNumbers.includes(partner)) {
      validSleeperPairs[primary] = partner;
      validSeatModes[primary] = 'sleeper';
    }
  });

  const newLabels = {};
  template.seats.forEach(seat => {
    if (validActiveSeats.includes(seat.seatNumber) && existingLabels[seat.seatNumber]) {
      newLabels[seat.seatNumber] = existingLabels[seat.seatNumber];
    } else {
      newLabels[seat.seatNumber] = seat.globalSeatIndex || seat.seatNumber;
    }
  });

  return {
    activeSeats: validActiveSeats.length > 0 ? validActiveSeats : templateSeatNumbers,
    blockedSeats: validBlockedSeats,
    labels: newLabels,
    sleeperPairs: validSleeperPairs,
    seatModes: validSeatModes
  };
};

  useEffect(() => {
    const loadRouteData = async () => {
      if (!bus || !bus.routeSchedules || bus.routeSchedules.length === 0) {
        console.log('No routeSchedules in bus:', bus);
        return;
      }

      console.log('Loading route data from bus:', bus);
      console.log('RouteSchedules:', bus.routeSchedules);

    const upSchedule = bus.routeSchedules.find(s => s.direction === 'UP');
      const downSchedule = bus.routeSchedules.find(s => s.direction === 'DOWN');

      if (upSchedule?.fareMatrix?.length > 0) {
        setFareMatrixUp(JSON.parse(JSON.stringify(upSchedule.fareMatrix)));

        const reconstructed = reconstructStopsFromMatrix(upSchedule.fareMatrix);
        setReconstructedRouteUp(reconstructed);

        if (reconstructed) {
          setSourceCity(reconstructed.origin?.city || '');
          setDestinationCity(reconstructed.destination?.city || '');

          let fullRoute = null;
          try {
            const routeId = upSchedule.routeId;
            console.log("Fetching route details for ID:", routeId);

            const response = await getRouteById(routeId, token);
            console.log("Full route response:", response);

            if (response && response.success && response.data) {
              fullRoute = response.data;
            } else if (response && response.data) {
              fullRoute = response.data;
            }
          } catch (err) {
            console.error("Error fetching route details:", err);
          }

          const localRouteName = bus.localRouteName || fullRoute?.localRouteName || null;
          console.log("Setting localRouteName:", localRouteName);

          setSelectedRoute({
            _id: upSchedule.routeId,
            routeName: upSchedule.routeName ||
              `${reconstructed.origin?.city} → ${reconstructed.destination?.city}`,
            localRouteName: localRouteName,
            origin: reconstructed.origin,
            destination: reconstructed.destination,
            intermediateStops: reconstructed.intermediateStops || [],
            routeDetails: reconstructed.routeDetails,
            stops: reconstructed.stops,
            returnJourney: downSchedule ? (() => {
              const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
              setReconstructedRouteDown(downReconstructed);
              return downReconstructed;
            })() : null
          });
        }
      }

      if (downSchedule?.fareMatrix?.length > 0) {
        setFareMatrixDown(JSON.parse(JSON.stringify(downSchedule.fareMatrix)));
        if (!upSchedule?.fareMatrix?.length) {
          const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
          setReconstructedRouteDown(downReconstructed);
        }
      }

      setInitialDataLoaded(true);
    };

    loadRouteData();
  }, [bus, token]);

  const reconstructStopsFromMatrix = (fareMatrix) => {
    if (!fareMatrix || fareMatrix.length === 0) return null;

    const stops = [];
    stops.push({
      id: fareMatrix[0].fromId || 'origin',
      name: fareMatrix[0].fromName,
      distanceFromOrigin: 0,
      type: fareMatrix[0].fromType || 'origin'
    });

    const firstRowCells = fareMatrix[0].toCells || [];
    firstRowCells.forEach((cell) => {
      if (cell) {
        stops.push({
          id: cell.toId || cell.toName,
          name: cell.toName,
          distanceFromOrigin: parseFloat(cell.distanceKm) || 0,
          type: 'stop'
        });
      }
    });

    if (stops.length > 1) {
      stops[stops.length - 1].type = 'destination';
    }

    return {
      stops,
      origin: { city: stops[0]?.name },
      destination: { city: stops[stops.length - 1]?.name },
      intermediateStops: stops.slice(1, -1).map((s, idx) => ({
        city: s.name,
        distanceFromOrigin: s.distanceFromOrigin,
        sequence: idx + 1
      })),
      routeDetails: {
        totalDistance: stops[stops.length - 1]?.distanceFromOrigin || 0
      }
    };
  };

  const handleTicketBookingTypeChange = (type) => {
    setTicketBookingType(prev => {
      let newState;
      if (type === 'instantTicket') {
        newState = {
          ...prev,
          instantTicket: !prev.instantTicket,
          both: false
        };
        if (newState.instantTicket && prev.seatBooking) {
          newState.both = true;
        }
        return newState;
      } else if (type === 'seatBooking') {
        newState = {
          ...prev,
          seatBooking: !prev.seatBooking,
          both: false
        };
        if (prev.instantTicket && newState.seatBooking) {
          newState.both = true;
        }
        return newState;
      }
      return prev;
    });
  };

  const generateMatrixForRoute = (routeData) => {
    if (!routeData) return [];

    const baseP = parseFloat(pricing.basePrice) || 0;
    const baseD = parseFloat(pricing.baseDistance) || 0;
    const costK = parseFloat(pricing.costPerKm) || 0;
    const multiplier = getCategoryMultiplier();

    let allStops = [];

    if (routeData.stops && routeData.stops.length > 0) {
      allStops = routeData.stops.map(s => ({
        id: s.id || s.name,
        name: s.name,
        distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
        type: s.type
      }));
    } else {
      const sortedStops = [...(routeData.intermediateStops || [])]
        .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

      allStops = [
        {
          id: 'origin',
          name: routeData.origin?.city || 'Origin',
          distanceFromOrigin: 0,
          type: 'origin'
        },
        ...sortedStops.map((s, i) => ({
          id: s._id || `stop_${i}`,
          name: s.city || s.name || `Stop ${i + 1}`,
          distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
          type: 'stop',
          sequence: s.sequence
        })),
        {
          id: 'destination',
          name: routeData.destination?.city || 'Destination',
          distanceFromOrigin:
            parseFloat(routeData.destination?.distanceFromOrigin) ||
            parseFloat(routeData.routeDetails?.totalDistance) || 0,
          type: 'destination'
        }
      ];
    }

    const matrix = allStops.map((fromStop, i) => {
      const toCells = allStops.map((toStop, j) => {
        if (j > i) {
          const distance = parseFloat(
            (toStop.distanceFromOrigin - fromStop.distanceFromOrigin).toFixed(1)
          );
          let price = baseP;
          if (distance > baseD) {
            price += (distance - baseD) * costK;
          }
          price = Math.round(price * multiplier);

          return {
            toId: toStop.id,
            toName: toStop.name,
            distanceKm: distance,
            price: price
          };
        }
        return null;
      });

      return {
        fromId: fromStop.id,
        fromName: fromStop.name,
        fromType: fromStop.type,
        toCells: toCells
      };
    });

    return matrix.filter(row => row.fromType !== 'destination');
  };
useEffect(() => {
  if (bus) {
    console.log('Loading bus data for edit123 :', bus);
    console.log('Bus seats:', bus.seats);
    console.log('Ticket booking type:', bus.ticketBookingType);

    setForm({
      busNumber: bus.busNumber || '',
      busName: bus.busName || '',
      busType: bus.busType || 'AC',
      busCategory: bus.busCategory || 'Seater',
      amenities: bus.amenities || []
    });

    setTripType(bus.tripType || 'oneWay');

    if (bus.ticketBookingType) {
      setTicketBookingType({
        instantTicket: bus.ticketBookingType.instantTicket || false,
        seatBooking: bus.ticketBookingType.seatBooking || false,
        both: bus.ticketBookingType.both || false
      });
      console.log('✅ Ticket booking type set:', bus.ticketBookingType);
    } else {
      setTicketBookingType({
        instantTicket: true,
        seatBooking: true,
        both: true
      });
    }

    if (bus.bookingClosedBefore) {
      setBookingClosedBefore(bus.bookingClosedBefore);
    }

    if (bus.cancellationTime) {
      setCancellationTime(bus.cancellationTime);
    } else {
      setCancellationTime({ hours: 1, minutes: 0 });
    }

    if (bus.platformFee) {
      setPlatformFee({
        type: bus.platformFee.type || 'fixed',
        value: bus.platformFee.value || 0,
        applicableOn: bus.platformFee.applicableOn || 'per_ticket'
      });
    }

    if (bus.operatingDays && bus.operatingDays.length > 0) {
      setOperatingDays(bus.operatingDays);
    }

    if (bus.fareDetails) {
      setPricing({
        basePrice: bus.fareDetails.basePrice || '',
        baseDistance: bus.fareDetails.baseDistance || '',
        costPerKm: bus.fareDetails.costPerKm || ''
      });
    }

    if (bus.images && bus.images.length > 0) {
      setExistingImages(bus.images);
    }
    if (bus.video && bus.video.length > 0) {
      setExistingVideo(bus.video[0]);
    }

    if (bus.seatConfiguration) {
      const config = bus.seatConfiguration.busType || '2*2';
      setSelectedConfiguration(config);
      console.log('Set configuration from bus:', config);
    }

    if (bus.seats && bus.seats.length > 0) {
      const activeSeatNumbers = bus.seats
        .filter(seat => seat.isAvailable !== false)
        .map(seat => seat.seatNumber);
      setActiveSeats(activeSeatNumbers);

      const blockedSeatNumbers = bus.seats
        .filter(seat => seat.isBlocked === true)
        .map(seat => seat.seatNumber);
      setBlockedSeats(blockedSeatNumbers);

      setSeatModes({});
      setSleeperPairs({});

      const seatLabels = {};
      bus.seats.forEach(seat => {
        const displayLabel = seat.globalSeatIndex || seat.seatNumber;
        seatLabels[seat.seatNumber] = displayLabel;
      });
      setCustomSeatLabels(seatLabels);

      console.log('Loaded seat labels from database:', seatLabels);
      console.log('Active seats:', activeSeatNumbers);
      console.log('Blocked seats:', blockedSeatNumbers);
    }
  }
}, [bus]);

  useEffect(() => {
    if (selectedConfiguration && form.busCategory) {
      fetchLayouts(selectedConfiguration);
    }
  }, [selectedConfiguration, form.busCategory]);

  const fetchAvailableConfigurations = async () => {
    try {
      setLoadingLayouts(true);
      const response = await getAllCategory(token, form.busCategory);
      if (response && response.success && response.data) {
        const configs = [...new Set(response.data.map(cat => cat.configuration))];
        if (configs.length > 0) {
          setAvailableConfigurations(configs);
          if (!selectedConfiguration || !configs.includes(selectedConfiguration)) {
            setSelectedConfiguration(configs[0]);
          }
        } else {
          setAvailableConfigurations([]);
        }
      }
    } catch (error) {
      console.error('Error fetching configurations:', error);
      setAvailableConfigurations([]);
    } finally {
      setLoadingLayouts(false);
    }
  };

const fetchLayouts = async (config) => {
  try {
    if (!config) return;
    setLoadingLayouts(true);
    let bustype = config.replace('x', '*');
    const response = await getSeatLayoutsByBustype(bustype, token);

    if (response && response.success && response.data && Array.isArray(response.data)) {
      let filteredLayouts = response.data;
      if (form.busCategory === 'Seater') {
        filteredLayouts = response.data.filter(layout =>
          layout.seatType === 'seat' || layout.seatType === 'seater');
      } else if (form.busCategory === 'Sleeper') {
        filteredLayouts = response.data.filter(layout => layout.seatType === 'sleeper');
      } else if (form.busCategory === 'Seater+Sleeper') {
        filteredLayouts = response.data.filter(layout =>
          layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper');
      }
      setLayoutTemplates(filteredLayouts);

      if (bus && bus.seats && bus.seats.length > 0 && filteredLayouts.length > 0) {
        const totalSeats = bus.seats.length;
        const existingConfig = bus.seatConfiguration?.busType || config;

        let matchingTemplate = filteredLayouts.find(template => {
          if (template.totalSeats === totalSeats) {
            return template.configuration === existingConfig ||
              template.configuration === existingConfig.replace('*', 'x');
          }
          return false;
        });

        if (!matchingTemplate) {
          matchingTemplate = filteredLayouts.find(template =>
            template.configuration === existingConfig ||
            template.configuration === existingConfig.replace('*', 'x')
          );
        }

        const autoSelected = matchingTemplate || filteredLayouts[0];

        if (autoSelected && !selectedTemplate) {
          setSelectedTemplate(autoSelected);
          console.log('Auto-selected template from fetchLayouts:', autoSelected.name);

          if (autoSelected.seats && autoSelected.seats.length > 0) {
            const activeByPos = new Set(
              bus.seats.filter(s => s.isAvailable !== false).map(s => `${s.row}-${s.column}`)
            );
            const blockedByPos = new Set(
              bus.seats.filter(s => s.isBlocked === true).map(s => `${s.row}-${s.column}`)
            );
            const labelByPos = {};
            const sleeperPosKeys = new Set();
            bus.seats.forEach(s => {
              labelByPos[`${s.row}-${s.column}`] = s.globalSeatIndex || s.seatNumber;
              if (s.seatSpan === 2) sleeperPosKeys.add(`${s.row}-${s.column}`);
            });

            const newActiveSeats = [];
            const newBlockedSeats = [];
            const newLabels = {};

            autoSelected.seats.forEach(ts => {
              const key = `${ts.row}-${ts.column}`;
              newLabels[ts.seatNumber] = labelByPos[key] || ts.globalSeatIndex || ts.seatNumber;
              if (activeByPos.has(key)) newActiveSeats.push(ts.seatNumber);
              if (blockedByPos.has(key)) newBlockedSeats.push(ts.seatNumber);
            });

            let leftCount = 2, rightCount = 2;
            if (autoSelected.configuration?.includes('*')) {
              const parts = autoSelected.configuration.split('*');
              leftCount = parseInt(parts[0]) || 2;
              rightCount = parseInt(parts[1]) || 2;
            }
            const sideOf = (col) => (col || 0) <= leftCount ? 'left' : 'right';

            const newSeatModes = {};
            const newSleeperPairs = {};
            const usedAsPartner = new Set();

            sleeperPosKeys.forEach(posKey => {
              const [row, col] = posKey.split('-').map(Number);
              const primarySeat = autoSelected.seats.find(s => s.row === row && s.column === col);
              if (!primarySeat) return;

              const side = sideOf(primarySeat.column);
              const sameRow = autoSelected.seats.filter(
                s => s.row === row && sideOf(s.column) === side
              );

              const isFree = (s) =>
                s.seatNumber !== primarySeat.seatNumber &&
                !usedAsPartner.has(s.seatNumber) &&
                !sleeperPosKeys.has(`${s.row}-${s.column}`);

              let partner = sameRow.find(s => s.column === primarySeat.column + 1 && isFree(s));
              if (!partner) partner = sameRow.find(s => s.column === primarySeat.column - 1 && isFree(s));

              if (partner) {
                newSeatModes[primarySeat.seatNumber] = 'sleeper';
                newSleeperPairs[primarySeat.seatNumber] = partner.seatNumber;
                usedAsPartner.add(partner.seatNumber);
                if (!newActiveSeats.includes(partner.seatNumber)) {
                  newActiveSeats.push(partner.seatNumber);
                }
              }
            });

            setActiveSeats(newActiveSeats);
            setBlockedSeats(newBlockedSeats);
            setCustomSeatLabels(newLabels);
            setSeatModes(newSeatModes);
            setSleeperPairs(newSleeperPairs);

            console.log('✅ Sleeper pairs reconstructed by position:', newSleeperPairs);
            console.log('✅ Final active seats:', newActiveSeats);
            console.log('✅ Final blocked seats:', newBlockedSeats);
          }
        }
      } else if (!selectedTemplate && filteredLayouts.length > 0) {
        setSelectedTemplate(filteredLayouts[0]);
        if (filteredLayouts[0].seats) {
          const seatNumbers = filteredLayouts[0].seats.map(s => s.seatNumber);
          setActiveSeats(seatNumbers);
          setBlockedSeats([]);
          setSeatModes({});
          setSleeperPairs({});
          const labels = {};
          filteredLayouts[0].seats.forEach(s => {
            labels[s.seatNumber] = s.globalSeatIndex || s.seatNumber;
          });
          setCustomSeatLabels(labels);
        }
      }
    } else {
      setLayoutTemplates([]);
    }
  } catch (error) {
    console.error("Layout Fetch Error:", error);
    setLayoutTemplates([]);
  } finally {
    setLoadingLayouts(false);
  }
};

  const fetchRoutesBySourceDestination = async () => {
    if (!sourceCity || !destinationCity) {
      setAvailableRoutes([]);
      return;
    }
    setLoadingRoutes(true);
    try {
      const response = await getAllBusownerAdminRoutes(
        token, 1, 50, '', '',
        { originCity: sourceCity, destinationCity: destinationCity }
      );
      console.log("Fetched routes response:", response);

      if (response && response.success && response.routes) {
        const routesWithLocalName = response.routes.map(route => ({
          ...route,
          localRouteName: route.localRouteName || null
        }));
        setAvailableRoutes(routesWithLocalName);
      } else {
        setAvailableRoutes([]);
      }
    } catch (error) {
      console.error('Error fetching routes:', error);
      setAvailableRoutes([]);
    } finally {
      setLoadingRoutes(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (sourceCity && destinationCity && !selectedRoute) {
        fetchRoutesBySourceDestination();
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [sourceCity, destinationCity]);

  useEffect(() => {
    if (form.busCategory) {
      fetchAvailableConfigurations();
    }
  }, [form.busCategory, token]);

  const getCategoryMultiplier = () => {
    const multipliers = { 'Seater': 1.0, 'Sleeper': 1.5, 'Seater+Sleeper': 1.3 };
    return multipliers[form.busCategory] || 1.0;
  };

  const getStopColor = (type) => {
    switch (type) {
      case 'origin': return '#4c51bf';
      case 'destination': return '#40c057';
      default: return '#667eea';
    }
  };

  const handleSelectRoute = (route) => {
    setSelectedRoute({
      ...route,
      stops: null,
      localRouteName: route.localRouteName
    });
    setShowRouteDropdown(false);
    setRouteSearchTerm('');
    setSourceCity(route.origin?.city || '');
    setDestinationCity(route.destination?.city || '');
    setFareMatrixUp([]);
    setFareMatrixDown([]);
    setReconstructedRouteUp(null);
    setReconstructedRouteDown(null);

    if (route.localRouteName) {
      toast.info(`Selected: ${route.localRouteName}`);
    }
  };

  const toggleDay = (day) => {
    setOperatingDays(prev =>
      prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
    );
  };

  const handleAmenityToggle = (amenity) => {
    setForm(prev => ({
      ...prev,
      amenities: prev.amenities.includes(amenity)
        ? prev.amenities.filter(a => a !== amenity)
        : [...prev.amenities, amenity]
    }));
  };

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    const newImages = [];
    files.forEach(file => {
      const reader = new FileReader();
      reader.onload = (e) => {
        newImages.push({ file: file, preview: e.target.result, name: file.name });
        if (newImages.length === files.length) {
          setSelectedImages(prev => [...prev, ...newImages]);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const removeExistingImage = (index) => {
    setExistingImages(prev => prev.filter((_, i) => i !== index));
  };

  const removeNewImage = (index) => {
    setSelectedImages(prev => prev.filter((_, i) => i !== index));
  };

  const handleVideoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedVideo({ file: file, preview: e.target.result, name: file.name });
      };
      reader.readAsDataURL(file);
    }
  };

  const removeExistingVideo = () => setExistingVideo(null);
  const removeNewVideo = () => setSelectedVideo(null);

  const handleBookingTimeChange = (field, value) => {
    setBookingClosedBefore(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
  };

  const handleCancellationTimeChange = (field, value) => {
    setCancellationTime(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
  };

  const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
    const isUp = type === 'up';
    const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];
    const updatedMatrix = currentMatrix.map((row, rIndex) => {
      if (rIndex !== rowIndex) return row;
      const newToCells = [...row.toCells];
      if (newToCells[colIndex]) {
        newToCells[colIndex] = { ...newToCells[colIndex], price: parseInt(newPrice) || 0 };
      }
      return { ...row, toCells: newToCells };
    });
    if (isUp) setFareMatrixUp(updatedMatrix);
    else setFareMatrixDown(updatedMatrix);
  };

const handleSelectTemplate = (template) => {
  setSelectedTemplate(template);
  setShowTemplateModal(false);
  setShowLayoutModal(true);

  if (template.seats && template.seats.length > 0) {
    const templateSeatNumbers = template.seats.map(s => s.seatNumber);
    
    const syncResult = syncSeatsWithTemplate(
      template,
      activeSeats,
      blockedSeats,
      customSeatLabels,
      sleeperPairs,
      seatModes
    );
    
    if (syncResult) {
      setActiveSeats(syncResult.activeSeats);
      setBlockedSeats(syncResult.blockedSeats);
      setCustomSeatLabels(syncResult.labels);
      setSleeperPairs(syncResult.sleeperPairs || {});
      setSeatModes(syncResult.seatModes || {});
    }
  }

  toast.success(`Selected template: ${template.name}`);
};

  const handleSeatPress = (seatObj) => {
    setEditingSeat(seatObj.seatNumber);

    const existingLabel = customSeatLabels[seatObj.seatNumber];

    if (activeSeats.includes(seatObj.seatNumber)) {
      setTempSeatLabel(String(existingLabel || seatObj.globalSeatIndex || seatObj.seatNumber));
    } else {
      setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
    }
  };

  const autoRenumberSeats = () => {
    if (!selectedTemplate || !selectedTemplate.seats) return;
    const sortedSeats = [...selectedTemplate.seats].sort((a, b) => {
      if (a.row === b.row) return a.column - b.column;
      return a.row - b.row;
    });
    let counter = 1;
    const newLabels = {};
    const consumedSet = new Set(Object.values(sleeperPairs));
    sortedSeats.forEach(s => {
      if (activeSeats.includes(s.seatNumber) && !consumedSet.has(s.seatNumber)) {
        newLabels[s.seatNumber] = String(counter++);
      }
    });
    setCustomSeatLabels(newLabels);
  };

  const getSeatPosition = (column) => {
    switch (parseInt(column)) {
      case 1: return 'window';
      case 2: return 'middle';
      case 3: return 'aisle';
      case 4: return 'window';
      default: return 'aisle';
    }
  };

  const handleUpdateBus = async () => {
    try {
      setIsSubmitting(true);
      setError(null);

      if (!ticketBookingType.instantTicket && !ticketBookingType.seatBooking) {
        toast.error('Please select at least one booking option (Instant Ticket or Seat Booking)');
        setIsSubmitting(false);
        return;
      }

      if (!form.busNumber) throw new Error('Bus Number is required');
      if (!form.busName) throw new Error('Bus Name is required');
      if (!form.busType) throw new Error('Bus Type is required');
      if (!form.busCategory) throw new Error('Bus Category is required');
      if (operatingDays.length === 0) throw new Error('Please select at least one operating day');

      const amenitiesArray = form.amenities || [];

    let finalSeatsPayload = [];
      let bookableSeatCount = activeSeats.length || bus.totalSeats || 0;

      if (selectedTemplate && selectedTemplate.seats) {
        const consumedSet = new Set(Object.values(sleeperPairs));

        const bookableSeatsInOrder = selectedTemplate.seats
          .filter(s => activeSeats.includes(s.seatNumber) && !consumedSet.has(s.seatNumber))
          .sort((a, b) => {
            if (a.row !== b.row) return a.row - b.row;
            return (a.column || 0) - (b.column || 0);
          });

        const seatPrefixMatch = (selectedTemplate.seats[0]?.seatNumber || 'S').match(/^[A-Za-z]+/);
        const seatPrefix = seatPrefixMatch ? seatPrefixMatch[0] : 'S';

        finalSeatsPayload = bookableSeatsInOrder.map((s, idx) => {
          const sequentialSeatNumber = `${seatPrefix}${idx + 1}`;

          const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
          const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
          const isBlocked = blockedSeats.includes(s.seatNumber);

          const isMergedSleeper = seatModes[s.seatNumber] === 'sleeper';

          return {
            seatNumber: sequentialSeatNumber,
            globalSeatIndex: finalGlobalIndex,
            row: s.row,
            column: s.column,
            seatType: isMergedSleeper ? 'sleeper' : 'seater',
            position: s.position || getSeatPosition(s.column),
            isBlocked: isBlocked,
            isAvailable: !isBlocked,
            ...(isMergedSleeper ? { seatSpan: 2 } : {})
          };
        });

        bookableSeatCount = bookableSeatsInOrder.length;
      } else if (bus.seats) {
        finalSeatsPayload = bus.seats.map(seat => {
          const label = customSeatLabels[seat.seatNumber] || seat.globalSeatIndex || seat.seatNumber;
          return {
            ...seat,
            globalSeatIndex: label,
          };
        });
      }

      const seatConfigPayload = {
        busType: selectedTemplate?.configuration || selectedConfiguration || '2*2',
        totalSeats: bookableSeatCount
      };

      const formData = new FormData();
      formData.append('busNumber', form.busNumber.toUpperCase().trim());
      formData.append('busName', form.busName.trim());
      formData.append('busType', form.busType);
      formData.append('busCategory', form.busCategory);
      formData.append('totalSeats', String(activeSeats.length || bus.totalSeats || 0));
      formData.append('tripType', tripType);
      formData.append('busClass', 'Economy');
      formData.append('amenities', JSON.stringify(amenitiesArray));
      formData.append('seats', JSON.stringify(finalSeatsPayload));
      formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
      formData.append('operatingDays', JSON.stringify(operatingDays));
      formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
      formData.append('cancellationTime', JSON.stringify(cancellationTime));
      formData.append('isActive', bus.isActive !== undefined ? bus.isActive : true);

      const ticketBookingTypeData = {
        instantTicket: ticketBookingType.instantTicket,
        seatBooking: ticketBookingType.seatBooking,
        both: ticketBookingType.instantTicket && ticketBookingType.seatBooking
      };
      formData.append('ticketBookingType', JSON.stringify(ticketBookingTypeData));

      const cleanPlatformFee = {
        type: platformFee.type || 'fixed',
        value: parseFloat(platformFee.value) || 0,
        applicableOn: platformFee.applicableOn || 'per_ticket'
      };
      formData.append('platformFee', JSON.stringify(cleanPlatformFee));

      const fareDetails = {
        basePrice: parseFloat(pricing.basePrice) || 0,
        baseDistance: parseFloat(pricing.baseDistance) || 0,
        costPerKm: parseFloat(pricing.costPerKm) || 0
      };
      formData.append('fareDetails', JSON.stringify(fareDetails));

      let routeSchedulesToSend = [];

      if (selectedRoute) {
        const upSchedule = {
          routeId: selectedRoute._id,
          routeNumber: selectedRoute.routeNumber || `Route-${selectedRoute.origin?.city}-${selectedRoute.destination?.city}`,
          routeName: selectedRoute.routeName || `${selectedRoute.origin?.city} to ${selectedRoute.destination?.city}`,
          direction: 'UP',
          operatingDays: operatingDays,
          fareMatrix: fareMatrixUp,
          origin: {
            city: selectedRoute.origin?.city || sourceCity,
            state: selectedRoute.origin?.state || 'West Bengal',
            address: selectedRoute.origin?.address || `${sourceCity}, West Bengal`,
            terminal: selectedRoute.origin?.terminal || `${sourceCity} Terminal`,
            departureTime: selectedRoute.origin?.departureTime || '08:00',
            timings: selectedRoute.origin?.timings || [
              { timeSlotSequence: 1, departureTime: '08:00', arrivalTime: '' },
              { timeSlotSequence: 2, departureTime: '12:00', arrivalTime: '' }
            ],
            coordinates: selectedRoute.origin?.coordinates || { lat: 0, lng: 0 }
          },
          destination: {
            city: selectedRoute.destination?.city || destinationCity,
            state: selectedRoute.destination?.state || 'West Bengal',
            address: selectedRoute.destination?.address || `${destinationCity}, West Bengal`,
            terminal: selectedRoute.destination?.terminal || `${destinationCity} Terminal`,
            arrivalTime: selectedRoute.destination?.arrivalTime || '10:00',
            timings: selectedRoute.destination?.timings || [
              { timeSlotSequence: 1, arrivalTime: '10:00', departureTime: '' },
              { timeSlotSequence: 2, arrivalTime: '14:00', departureTime: '' }
            ],
            coordinates: selectedRoute.destination?.coordinates || { lat: 0, lng: 0 },
            distanceFromOrigin: selectedRoute.destination?.distanceFromOrigin || selectedRoute.routeDetails?.totalDistance || 100
          },
          intermediateStops: selectedRoute.intermediateStops || [],
          additionalBoardingPoints: selectedRoute.additionalBoardingPoints || [],
          additionalDroppingPoints: selectedRoute.additionalDroppingPoints || [],
          additionalNullPoints: selectedRoute.additionalNullPoints || [],
          routeDetails: {
            totalDistance: selectedRoute.routeDetails?.totalDistance || 100,
            estimatedDuration: selectedRoute.routeDetails?.estimatedDuration || { hours: 1, minutes: 0 }
          },
          isActive: true,
          validFrom: new Date()
        };

        routeSchedulesToSend.push(upSchedule);

        if (tripType === 'roundTrip') {
          const returnJourney = selectedRoute.returnJourney;

          if (returnJourney || fareMatrixDown.length > 0) {
            const downSchedule = {
              routeId: selectedRoute._id,
              routeNumber: selectedRoute.routeNumber || `Route-${selectedRoute.origin?.city}-${selectedRoute.destination?.city}`,
              routeName: selectedRoute.routeName || `${selectedRoute.origin?.city} to ${selectedRoute.destination?.city}`,
              direction: 'DOWN',
              operatingDays: operatingDays,
              fareMatrix: fareMatrixDown,
              origin: {
                city: returnJourney?.origin?.city || selectedRoute.destination?.city || destinationCity,
                state: returnJourney?.origin?.state || selectedRoute.destination?.state || 'West Bengal',
                address: returnJourney?.origin?.address || selectedRoute.destination?.address || `${destinationCity}, West Bengal`,
                terminal: returnJourney?.origin?.terminal || selectedRoute.destination?.terminal || `${destinationCity} Terminal`,
                departureTime: returnJourney?.origin?.departureTime || '14:00',
                timings: returnJourney?.origin?.timings || [
                  { timeSlotSequence: 1, departureTime: '14:00', arrivalTime: '' },
                  { timeSlotSequence: 2, departureTime: '18:00', arrivalTime: '' }
                ],
                coordinates: returnJourney?.origin?.coordinates || selectedRoute.destination?.coordinates || { lat: 0, lng: 0 }
              },
              destination: {
                city: returnJourney?.destination?.city || selectedRoute.origin?.city || sourceCity,
                state: returnJourney?.destination?.state || selectedRoute.origin?.state || 'West Bengal',
                address: returnJourney?.destination?.address || selectedRoute.origin?.address || `${sourceCity}, West Bengal`,
                terminal: returnJourney?.destination?.terminal || selectedRoute.origin?.terminal || `${sourceCity} Terminal`,
                arrivalTime: returnJourney?.destination?.arrivalTime || '16:00',
                timings: returnJourney?.destination?.timings || [
                  { timeSlotSequence: 1, arrivalTime: '16:00', departureTime: '' },
                  { timeSlotSequence: 2, arrivalTime: '20:00', departureTime: '' }
                ],
                coordinates: returnJourney?.destination?.coordinates || selectedRoute.origin?.coordinates || { lat: 0, lng: 0 },
                distanceFromOrigin: returnJourney?.destination?.distanceFromOrigin || selectedRoute.routeDetails?.totalDistance || 100
              },
              intermediateStops: returnJourney?.intermediateStops || [],
              additionalBoardingPoints: returnJourney?.additionalBoardingPoints || [],
              additionalDroppingPoints: returnJourney?.additionalDroppingPoints || [],
              additionalNullPoints: returnJourney?.additionalNullPoints || [],
              routeDetails: {
                totalDistance: returnJourney?.routeDetails?.totalDistance || selectedRoute.routeDetails?.totalDistance || 100,
                estimatedDuration: returnJourney?.routeDetails?.estimatedDuration || { hours: 1, minutes: 0 }
              },
              isActive: true,
              validFrom: new Date()
            };

            routeSchedulesToSend.push(downSchedule);
          }
        }

        console.log('Sending routeSchedules with fareMatrix:', JSON.stringify(routeSchedulesToSend, null, 2));
        formData.append('routeSchedules', JSON.stringify(routeSchedulesToSend));

        if (selectedRoute.localRouteName) {
          formData.append('localRouteName', selectedRoute.localRouteName);
        }

      } else if (bus.routeSchedules) {
        formData.append('routeSchedules', JSON.stringify(bus.routeSchedules));
        if (bus.localRouteName) {
          formData.append('localRouteName', bus.localRouteName);
        }
      }

      if (existingImages.length > 0) {
        formData.append('existingImages', JSON.stringify(existingImages));
      }
      selectedImages.forEach((img) => {
        if (img.file) formData.append('images', img.file);
      });
      if (existingVideo) {
        formData.append('existingVideo', existingVideo);
      }
      if (selectedVideo && selectedVideo.file) {
        formData.append('videos', selectedVideo.file);
      }

    const response = isPending
        ? await updatePendingBus(bus._id, formData, token)
        : await updateBus(bus._id, formData, token);

      if (response && response.success) {
        toast.success(isPending ? 'Pending bus updated successfully!' : 'Bus updated successfully!');
        if (onUpdate) onUpdate(response.data);
        onClose();
      } else {
        throw new Error(response?.message || 'Failed to update bus');
      }
    } catch (err) {
      console.error('Error updating bus:', err);
      setError(err.message || 'Failed to update bus');
      toast.error(err.message || 'Failed to update bus');
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderMatrix = (type) => {
    const isUp = type === 'up';
    const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
    const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

    if (!currentRoute || !currentMatrix || currentMatrix.length === 0) return (
      <div className="matrix-placeholder">
        <p>No fare matrix available. Please go back and generate the matrix.</p>
      </div>
    );

    const allStops = [];
    currentMatrix.forEach(row => {
      if (!allStops.find(s => s.name === row.fromName)) {
        allStops.push({ name: row.fromName, type: row.fromType });
      }
    });
    const firstRowLastCell = currentMatrix[0]?.toCells?.filter(Boolean).pop();
    if (firstRowLastCell && !allStops.find(s => s.name === firstRowLastCell.toName)) {
      allStops.push({ name: firstRowLastCell.toName, type: 'destination' });
    }

    return (
      <div className="matrix-section">
        <h5 className="matrix-title">{isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}</h5>
        <div className="matrix-container">
          <div className="matrix-table-wrapper">
            <table className="fare-matrix-table">
              <thead>
                <tr>
                  <th className="corner-cell">From \ To</th>
                  {allStops.map((stop, i) => (
                    <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
                      <div className="stop-header">
                        <span className="stop-name">{stop.name}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentMatrix.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
                      <div className="from-stop">
                        <span className="stop-name">{row.fromName}</span>
                      </div>
                    </td>
                    {allStops.map((stop, colIndex) => {
                      const matchingCell = row.toCells?.find(cell => cell && cell.toName === stop.name);
                      if (matchingCell) {
                        return (
                          <td key={colIndex} className="price-cell">
                            <div className="fare-cell">
                              <span className="distance">{matchingCell.distanceKm || 0} km</span>
                              <div className="price-input-group">
                                <span className="currency">₹</span>
                                <input
                                  type="text"
                                  className="matrix-input"
                                  value={matchingCell.price}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '' || /^\d+$/.test(value)) {
                                      const actualColIndex = row.toCells.findIndex(
                                        cell => cell && cell.toName === stop.name
                                      );
                                      handlePriceChange(type, rowIndex, actualColIndex, value);
                                    }
                                  }}
                                  min="0"
                                  step="1"
                                  pattern="\d*"
                                  inputMode="numeric"
                                />
                              </div>
                            </div>
                          </td>
                        );
                      }
                      return <td key={colIndex} className="na-cell">—</td>;
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };
const renderSeatVisualizer = () => {
  if (!selectedTemplate) return (
    <div className="seat-placeholder">
      <p>Select a template to configure seats</p>
      <button type="button" className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
        Select Template
      </button>
    </div>
  );

  if (!selectedTemplate.seats || selectedTemplate.seats.length === 0) {
    return <div className="seat-placeholder">No seats available in this template</div>;
  }

  const { seats, configuration } = selectedTemplate;
  let leftCount = 2, rightCount = 2;
  if (configuration && configuration.includes('*')) {
    const parts = configuration.split('*');
    leftCount = parseInt(parts[0]) || 2;
    rightCount = parseInt(parts[1]) || 2;
  }

  const seatsByRow = {};
  seats.forEach(seat => {
    if (!seatsByRow[seat.row]) seatsByRow[seat.row] = [];
    seatsByRow[seat.row].push(seat);
  });

  const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);
  const rows = [];

  const renderSeat = (seatObj) => {
    const consumedSet = new Set(Object.values(sleeperPairs));
    if (consumedSet.has(seatObj.seatNumber))
      return null;

    const isSelected = activeSeats.includes(seatObj.seatNumber);
    const isBlocked = blockedSeats.includes(seatObj.seatNumber);
    const isMergedSleeper = seatModes[seatObj.seatNumber] === 'sleeper';

    const isSleeper = isMergedSleeper ||
      seatObj.seatType === 'sleeper' ||
      seatObj.seatType === 'seat+sleeper' ||
      selectedTemplate.seatType === 'sleeper' ||
      selectedTemplate.seatType === 'seater+sleeper';

    let displayLabel = '';
    if (isSelected) {
      if (customSeatLabels[seatObj.seatNumber]) {
        displayLabel = customSeatLabels[seatObj.seatNumber];
      } else if (seatObj.globalSeatIndex) {
        displayLabel = seatObj.globalSeatIndex;
      } else {
        displayLabel = seatObj.seatNumber;
      }
    }

    let seatClass = '';
    if (isSelected) {
      seatClass = isBlocked ? 'blocked' : 'selected';
    } else {
      seatClass = 'inactive';
    }

    const showSleeperCheckbox = isSleeperEligible() && isSelected && !isBlocked;

    return (
      <div key={seatObj.seatNumber} className="seat-wrapper" style={{ position: 'relative' }}>
        <button
          className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${isMergedSleeper ? 'sleeper-merged' : ''} ${seatClass}`}
          onClick={() => handleSeatPress(seatObj)}
          type="button"
          style={isBlocked ? {
            backgroundColor: '#dc3545',
            color: 'white',
            borderColor: '#bd2130'
          } : {}}
        >
          <span className="seat-number">{displayLabel}</span>
          {isMergedSleeper && <span className="sleeper-tag">Sleeper</span>}
        </button>

        {showSleeperCheckbox && (
          <label
            className="sleeper-checkbox-overlay"
            onClick={(e) => e.stopPropagation()}
            title={isMergedSleeper ? 'Unmark sleeper' : 'Mark as sleeper (merges with adjacent seat)'}
            style={{
              position: 'absolute', top: '-6px', right: '-6px',
              background: '#fff', borderRadius: '50%', width: '16px', height: '16px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 1px 3px rgba(0,0,0,0.3)', cursor: 'pointer'
            }}
          >
            <input
              type="checkbox"
              checked={isMergedSleeper}
              onChange={() => handleToggleSleeper(seatObj)}
              style={{ width: '12px', height: '12px', margin: 0 }}
            />
          </label>
        )}
      </div>
    );
  };

  rowNumbers.forEach(rowNum => {
    const seatsInRow = seatsByRow[rowNum];
    const leftSeats = seatsInRow.filter(s => (s.column || 0) <= leftCount)
      .sort((a, b) => (a.column || 0) - (b.column || 0));
    const rightSeats = seatsInRow.filter(s => (s.column || 0) > leftCount)
      .sort((a, b) => (a.column || 0) - (b.column || 0));

    const renderedLeft = leftSeats.map(seat => renderSeat(seat)).filter(Boolean);
    const renderedRight = rightSeats.map(seat => renderSeat(seat)).filter(Boolean);

    rows.push(
      <div key={`row-${rowNum}`} className="seat-row">
        <div className="left-seats">{renderedLeft}</div>
        <div className="aisle">Aisle</div>
        <div className="right-seats">{renderedRight}</div>
      </div>
    );
  });

  return (
    <div className="seat-layout-visualizer">
      <div className="bus-header"><div className="driver-area">Driver</div></div>
      <div className="bus-body">{rows}</div>
      <div className="seat-legend">
        <div className="legend-item"><div className="seat-sample selected"></div><span>Active ({activeSeats.length})</span></div>
        <div className="legend-item"><div className="seat-sample blocked"></div><span>Blocked ({blockedSeats.length})</span></div>
        <div className="legend-item"><div className="seat-sample sleeper"></div><span>Sleeper ({Object.keys(seatModes).length})</span></div>
        <div className="legend-item"><div className="seat-sample inactive"></div><span>Inactive</span></div>
      </div>
      <button className="auto-number-btn" onClick={autoRenumberSeats} style={{ marginTop: '10px' }}>
        Auto-Number Seats
      </button>
    </div>
  );
};

  const ProgressSteps = () => (
    <div className="progress-steps">
      <div className={`step ${activeTab === 'basic' ? 'active' : ''}`}>
        <div className="step-icon">1</div><div className="step-label">Basic Info</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'route' ? 'active' : ''}`}>
        <div className="step-icon">2</div><div className="step-label">Route & Pricing</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'matrix' ? 'active' : ''}`}>
        <div className="step-icon">3</div><div className="step-label">Fare Matrix</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
        <div className="step-icon">4</div><div className="step-label">Seat Layout</div>
      </div>
    </div>
  );

  const renderSeatEditModal = () => {
    const seatObj = selectedTemplate?.seats?.find(s => s.seatNumber === editingSeat);
    const isMergedSleeper = seatModes[editingSeat] === 'sleeper';
    const canOfferSleeper = seatObj && isSleeperEligible() && (isMergedSleeper || findSleeperPartner(seatObj));

    return (
      <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
        <div className="modal-content seat-edit-modal" style={{ maxWidth: "500px", maxHeight: "35vh" }} onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Set Seat Label</h3>
          </div>
          <div className="modal-body">
            <input
              type="text"
              value={tempSeatLabel}
              onChange={(e) => setTempSeatLabel(e.target.value)}
              placeholder="e.g., S1, B1, 1A, etc."
              autoFocus
            />
            <small style={{ display: 'block', marginTop: '5px', color: '#666' }}>
              Current seat number: {editingSeat}
            </small>

            {canOfferSleeper && (
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginTop: '12px',
                  fontSize: '13px',
                  cursor: 'pointer'
                }}
              >
                <input
                  type="checkbox"
                  checked={isMergedSleeper}
                  onChange={() => handleToggleSleeper(seatObj)}
                />
                Mark as Sleeper (merges with adjacent seat)
              </label>
            )}
          </div>
          <div className="modal-footer three-buttons">
            <button
              className="modal-action-btn disable-btn"
              onClick={() => {
                const partnerSeatNumber = sleeperPairs[editingSeat];
                if (partnerSeatNumber) {
                  setSeatModes(prev => {
                    const n = { ...prev };
                    delete n[editingSeat];
                    return n;
                  });
                  setSleeperPairs(prev => {
                    const n = { ...prev };
                    delete n[editingSeat];
                    return n;
                  });
                  setActiveSeats(prev => prev.filter(s => s !== partnerSeatNumber));
                }
                setActiveSeats(activeSeats.filter(s => s !== editingSeat));
                setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
                setEditingSeat(null);
              }}
            >
              Disable
            </button>
            <button
              className="modal-action-btn block-btn"
              onClick={() => {
                if (!activeSeats.includes(editingSeat)) {
                  setActiveSeats([...activeSeats, editingSeat]);
                }
                if (!blockedSeats.includes(editingSeat)) {
                  setBlockedSeats([...blockedSeats, editingSeat]);
                }
                if (tempSeatLabel.trim()) {
                  setCustomSeatLabels(prev => ({
                    ...prev,
                    [editingSeat]: tempSeatLabel.trim()
                  }));
                }
                setEditingSeat(null);
              }}
            >
              Block
            </button>
            <button
              className="modal-action-btn active-btn"
              onClick={() => {
                if (!activeSeats.includes(editingSeat)) {
                  setActiveSeats([...activeSeats, editingSeat]);
                }
                setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
                if (tempSeatLabel.trim()) {
                  setCustomSeatLabels(prev => ({
                    ...prev,
                    [editingSeat]: tempSeatLabel.trim()
                  }));
                }
                setEditingSeat(null);
              }}
            >
              Active
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderLayoutModal = () => (
    <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
      <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Configure Seats</h3>
          <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
        </div>
        <div className="modal-body">
          {renderSeatVisualizer()}
          <div className="layout-footer">
            <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>Done</button>
          </div>
        </div>
      </div>
    </div>
  );

  const renderTemplateModal = () => (
    <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
      <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Select Template</h3>
          <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
        </div>
        <div className="modal-body">
          <div className="templates-grid">
            {layoutTemplates.map(template => (
              <button key={template._id} className="template-card"
                onClick={() => handleSelectTemplate(template)}>
                <h4>{template.name}</h4>
                <div>Config: {template.configuration}</div>
                <div>Seats: {template.totalSeats}</div>
                <div>Type: {template.seatType || 'seat'}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const renderBasicInfoTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title"><h3>Edit Bus Information</h3></div>

      <div className="form-grid">
        <div className="input-group">
          <label>Bus Number *</label>
          <input type="text" value={form.busNumber}
            onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
            className="modern-input" />
        </div>
        <div className="input-group">
          <label>Bus Name *</label>
          <input type="text" value={form.busName}
            onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
            className="modern-input" />
        </div>
      </div>

      <div className="section-card">
        <h4>Bus Images</h4>
        {existingImages.length > 0 && (
          <div className="existing-images">
            <label>Current Images</label>
            <div className="images-grid">
              {existingImages.map((img, idx) => (
                <div key={idx} className="image-preview-item">
                  <img src={`https://admin.roamjssln.com/uploads/buses/images/${img}`} alt="bus" />
                  <button type="button" onClick={() => removeExistingImage(idx)} className="remove-image-btn">×</button>
                </div>
              ))}
            </div>
          </div>
        )}
        <input type="file" id="edit-bus-images" multiple accept="image/*"
          onChange={handleImageUpload} style={{ display: 'none' }} />
        <label htmlFor="edit-bus-images" className="image-upload-label">+ Add New Images</label>
        {selectedImages.length > 0 && (
          <div className="new-images">
            <div className="images-grid">
              {selectedImages.map((img, idx) => (
                <div key={idx} className="image-preview-item">
                  <img src={img.preview} alt="new" />
                  <button type="button" onClick={() => removeNewImage(idx)} className="remove-image-btn">×</button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">🎫</span>
          Ticket Booking Options
        </h4>
        <div className="booking-type-grid">
          <div className={`booking-type-item ${ticketBookingType.instantTicket ? 'active' : ''}`}>
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={ticketBookingType.instantTicket}
                onChange={() => handleTicketBookingTypeChange('instantTicket')}
                className="modern-checkbox"
              />
              <span className="checkbox-content">
                <span className="checkbox-icon">⚡</span>
                <span className="checkbox-text">
                  <span className="checkbox-title">Instant Ticket</span>
                  <span className="checkbox-subtitle">Generate ticket immediately on booking</span>
                </span>
              </span>
            </label>
          </div>

          <div className={`booking-type-item ${ticketBookingType.seatBooking ? 'active' : ''}`}>
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={ticketBookingType.seatBooking}
                onChange={() => handleTicketBookingTypeChange('seatBooking')}
                className="modern-checkbox"
              />
              <span className="checkbox-content">
                <span className="checkbox-icon">💺</span>
                <span className="checkbox-text">
                  <span className="checkbox-title">Seat Booking</span>
                  <span className="checkbox-subtitle">Reserve seats without immediate ticket</span>
                </span>
              </span>
            </label>
          </div>

          {ticketBookingType.instantTicket && ticketBookingType.seatBooking && (
            <div className="booking-type-summary both-selected">
              <span className="badge">✨ Both Enabled</span>
              <span>Passengers can book instantly or reserve seats</span>
            </div>
          )}

          {!ticketBookingType.instantTicket && !ticketBookingType.seatBooking && (
            <div className="booking-type-summary none-selected">
              <span className="badge warning">⚠️</span>
              <span>Please select at least one booking option</span>
            </div>
          )}
        </div>
        <small className="helper-text">
          Select one or both booking types. "Both" is automatically enabled when both options are selected.
        </small>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Bus Type *</label>
          <select value={form.busType}
            onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
            className="modern-select">
            {BUS_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Bus Category *</label>
          <select value={form.busCategory}
            onChange={(e) => setForm(prev => ({ ...prev, busCategory: e.target.value }))}
            className="modern-select">
            {BUS_CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
          </select>
        </div>
      </div>

      <div className="section-card">
        <h4>Booking Cut-off Time</h4>
        <div className="booking-time-container">
          <div className="time-input-group">
            <label>Hours before departure</label>
            <div className="time-input-wrapper">
              <input type="number" min="0" max="24" value={bookingClosedBefore.hours}
                onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
                className="modern-input time-input" />
              <span className="time-unit">hours</span>
            </div>
          </div>
          <div className="time-input-group">
            <label>Minutes before departure</label>
            <div className="time-input-wrapper">
              <input type="number" min="0" max="59" value={bookingClosedBefore.minutes}
                onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
                className="modern-input time-input" />
              <span className="time-unit">minutes</span>
            </div>
          </div>
        </div>
      </div>

      <div className="section-card">
        <h4>Cancellation Time</h4>
        <div className="booking-time-container">
          <div className="time-input-group">
            <label>Hours before departure</label>
            <div className="time-input-wrapper">
              <input type="number" min="0" max="48" value={cancellationTime.hours}
                onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
                className="modern-input time-input" />
              <span className="time-unit">hours</span>
            </div>
          </div>
          <div className="time-input-group">
            <label>Minutes before departure</label>
            <div className="time-input-wrapper">
              <input type="number" min="0" max="59" value={cancellationTime.minutes}
                onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
                className="modern-input time-input" />
              <span className="time-unit">minutes</span>
            </div>
          </div>
        </div>
        <small className="helper-text">Cancellation allowed up to this time before departure</small>
      </div>

      <PlatformFeeConfig platformFee={platformFee} onChange={setPlatformFee} />

      <div className="section-card">
        <h4>Amenities</h4>
        <div className="amenities-grid">
          {AMENITIES_LIST.map(amenity => (
            <label key={amenity} className="amenity-checkbox-label">
              <input type="checkbox" checked={form.amenities.includes(amenity)}
                onChange={() => handleAmenityToggle(amenity)} />
              <span>{amenity}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-actions">
        <button className="modern-btn primary" onClick={() => setActiveTab('route')}>Continue →</button>
      </div>
    </div>
  );

  const renderRouteTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title"><h3>Route & Pricing Configuration</h3></div>

      <div className="section-card">
        <h4>Trip Type</h4>
        <div className="trip-type-container">
          <button className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
            onClick={() => setTripType('oneWay')}>One Way</button>
          <button className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
            onClick={() => setTripType('roundTrip')}>Round Trip</button>
        </div>
      </div>

      <div className="section-card">
        <h4>Source & Destination</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Source City</label>
            <input type="text" value={sourceCity}
              onChange={(e) => { setSourceCity(e.target.value); setSelectedRoute(null); }}
              placeholder="Enter source city" className="modern-input" />
          </div>
          <div className="form-group">
            <label>Destination City</label>
            <input type="text" value={destinationCity}
              onChange={(e) => { setDestinationCity(e.target.value); setSelectedRoute(null); }}
              placeholder="Enter destination city" className="modern-input" />
          </div>
        </div>
      </div>

      {sourceCity && destinationCity && (
        <div className="section-card">
          <h4>Select Route</h4>
          <div className="route-selector">
            <label>Available Routes</label>
            <div className="route-dropdown-container">
              <input
                type="text"
                value={
                  selectedRoute
                    ? (selectedRoute.localRouteName || selectedRoute.routeName || `${selectedRoute.origin?.city} → ${selectedRoute.destination?.city}`)
                    : routeSearchTerm
                }
                onClick={() => setShowRouteDropdown(!showRouteDropdown)}
                onChange={(e) => {
                  setRouteSearchTerm(e.target.value);
                  setShowRouteDropdown(true);
                  setSelectedRoute(null);
                }}
                placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
                className="modern-input"
              />
              {showRouteDropdown && availableRoutes.length > 0 && (
                <div className="route-dropdown">
                  <div className="dropdown-search">
                    <input type="text" value={routeSearchTerm}
                      onChange={(e) => setRouteSearchTerm(e.target.value)}
                      placeholder="Search routes..." className="dropdown-search-input" autoFocus />
                  </div>
                  <div className="dropdown-list">
                    {availableRoutes
                      .filter(route =>
                        (route.localRouteName && route.localRouteName.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
                        (route.routeName && route.routeName.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
                        (route.origin?.city && route.origin.city.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
                        (route.destination?.city && route.destination.city.toLowerCase().includes(routeSearchTerm.toLowerCase()))
                      )
                      .map(route => {
                        return (
                          <div key={route._id} className="dropdown-item"
                            onClick={() => handleSelectRoute(route)}>

                            {route.localRouteName ? (
                              <>
                                <div className="route-number" style={{ fontWeight: 'bold', color: '#2c7da0' }}>
                                  📍 {route.localRouteName}
                                </div>
                                <div className="route-details" style={{ fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
                                  {route.origin?.city} → {route.destination?.city} • {route.routeDetails?.totalDistance || 0} km
                                  {route.isRoundTrip && ' • Round Trip'}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="route-number" style={{ fontWeight: '500' }}>
                                  {route.routeName || `${route.origin?.city} → ${route.destination?.city}`}
                                </div>
                                <div className="route-details" style={{ fontSize: '12px', color: '#6c757d' }}>
                                  {route.origin?.city} → {route.destination?.city} • {route.routeDetails?.totalDistance || 0} km
                                  {route.isRoundTrip && ' • Round Trip'}
                                </div>
                              </>
                            )}

                            {route.creatorType === 'BusOwner' && (
                              <span className="owner-badge" style={{
                                marginLeft: '8px',
                                fontSize: '10px',
                                backgroundColor: '#ffc107',
                                color: '#000',
                                padding: '2px 6px',
                                borderRadius: '4px'
                              }}>
                                Owner
                              </span>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}
            </div>
            {selectedRoute && (
              <small className="helper-text" style={{ color: 'green', marginTop: '5px', display: 'block' }}>
                ✓ Route selected: {selectedRoute.localRouteName || selectedRoute.routeName || `${selectedRoute.origin?.city} → ${selectedRoute.destination?.city}`}
              </small>
            )}
          </div>
        </div>
      )}

      <div className="section-card">
        <h4>Operating Days</h4>
        <div className="days-grid">
          {DAYS_OF_WEEK.map(day => (
            <button key={day} className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
              onClick={() => toggleDay(day)}>
              {day.substring(0, 3)}
            </button>
          ))}
        </div>
      </div>

      <div className="section-card">
        <h4>Pricing Configuration</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Base Price (₹) *</label>
            <input type="number" value={pricing.basePrice}
              onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
              placeholder="e.g., 100" className="modern-input" min="0" step="1" />
          </div>
          <div className="form-group">
            <label>Base Distance (km) *</label>
            <input type="number" value={pricing.baseDistance}
              onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
              placeholder="e.g., 15" className="modern-input" min="0" step="0.1" />
          </div>
          <div className="form-group">
            <label>Cost per km (₹) *</label>
            <input type="number" value={pricing.costPerKm}
              onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
              placeholder="e.g., 4" className="modern-input" min="0" step="0.1" />
          </div>
        </div>
        <small className="helper-text">These values are used to calculate fares. Changing them will regenerate the matrix.</small>
      </div>

      <div className="form-actions">
        <button className="modern-btn outline" onClick={() => setActiveTab('basic')}>← Back</button>
        <button
          className="modern-btn primary"
          onClick={() => {
            if (!selectedRoute) {
              toast.error('Please select a route first');
              return;
            }

            if (fareMatrixUp && fareMatrixUp.length > 0) {
              toast.info('Using existing fare matrix from bus data');
              setActiveTab('matrix');
              return;
            }

            if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
              toast.error('Please fill all pricing fields to generate matrix');
              return;
            }

            const newMatrixUp = generateMatrixForRoute(selectedRoute);
            setFareMatrixUp(newMatrixUp);

            if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
              const newMatrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
              setFareMatrixDown(newMatrixDown);
            }

            toast.success('Fare matrix generated with updated pricing!');
            setActiveTab('matrix');
          }}
        >
          {fareMatrixUp && fareMatrixUp.length > 0 ? 'View Fare Matrix →' : 'Generate Fare Matrix →'}
        </button>
      </div>
    </div>
  );

  const renderMatrixTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title"><h3>Fare Matrix Configuration</h3></div>

      <div className="matrix-info" style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#e8f4fd', borderRadius: '4px' }}>
        <p style={{ margin: 0, fontSize: '14px', color: '#2c7da0' }}>
          💡 You can edit individual prices by clicking on the price fields below.
          {fareMatrixUp && fareMatrixUp.length > 0 && ' The current matrix is loaded from the bus data.'}
        </p>
      </div>

      {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
        <div className="matrix-tabs">
          <button className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
            onClick={() => setActiveMatrixTab('up')}>Up Route</button>
          <button className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
            onClick={() => setActiveMatrixTab('down')}>Down Route</button>
        </div>
      )}

      {activeMatrixTab === 'up' && renderMatrix('up')}
      {activeMatrixTab === 'down' && renderMatrix('down')}

      <div className="form-actions">
        <button className="modern-btn outline" onClick={() => setActiveTab('route')}>← Back</button>
        <button
          className="modern-btn outline"
          onClick={() => {
            if (!selectedRoute) {
              toast.error('No route selected');
              return;
            }
            if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
              toast.error('Please fill all pricing fields in the Route tab');
              return;
            }
            if (window.confirm('This will regenerate the fare matrix with current pricing. Continue?')) {
              const newMatrixUp = generateMatrixForRoute(selectedRoute);
              setFareMatrixUp(newMatrixUp);
              if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
                const newMatrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
                setFareMatrixDown(newMatrixDown);
              }
              toast.success('Fare matrix regenerated!');
            }
          }}
          style={{ marginRight: '10px' }}
        >
          🔄 Regenerate
        </button>
        <button className="modern-btn primary" onClick={() => setActiveTab('seats')}>Continue →</button>
      </div>
    </div>
  );

  const renderSeatLayoutTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title"><h3>Seat Layout Configuration</h3></div>

      <div className="section-card">
        <h4>Bus Configuration</h4>
        <div className="config-buttons">
          {availableConfigurations.map(config => (
            <button key={config}
              className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
              onClick={() => {
                setSelectedConfiguration(config);
                setSelectedTemplate(null);
              }}>
              {config}
            </button>
          ))}
        </div>
        {selectedConfiguration && (
          <div className="config-info" style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
            Current configuration: <strong>{selectedConfiguration}</strong>
            {bus?.seatConfiguration?.busType && (
              <span style={{ marginLeft: '10px', color: '#2c7da0' }}>
                (Original: {bus.seatConfiguration.busType})
              </span>
            )}
          </div>
        )}
      </div>

      <div className="section-card">
        <h4>Select Template</h4>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          <button className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
            {selectedTemplate ? 'Change Template' : 'Select Layout Template'}
          </button>
          {selectedTemplate && (
            <span style={{ color: 'green', fontWeight: '500' }}>
              ✓ {selectedTemplate.name} ({selectedTemplate.totalSeats} seats)
            </span>
          )}
        </div>
        {!selectedTemplate && layoutTemplates.length > 0 && (
          <div style={{ marginTop: '10px', fontSize: '13px', color: '#856404', backgroundColor: '#fff3cd', padding: '10px', borderRadius: '4px' }}>
            ⚠️ Please select a template to configure seats
          </div>
        )}
        {loadingLayouts && (
          <div style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
            Loading templates...
          </div>
        )}
        {layoutTemplates.length === 0 && !loadingLayouts && (
          <div style={{ marginTop: '10px', fontSize: '13px', color: '#dc3545' }}>
            No templates available for this configuration
          </div>
        )}
      </div>

      {selectedTemplate && (
        <div className="section-card">
          <h4>Seat Layout</h4>
          <button className="view-layout-btn" onClick={() => setShowLayoutModal(true)}>
            View / Edit Seats
          </button>
          <div className="seat-summary" style={{ marginTop: '10px' }}>
            <strong>Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || 0}</strong>
            {blockedSeats.length > 0 && (
              <span style={{ marginLeft: '15px', color: '#dc3545' }}>
                Blocked: {blockedSeats.length}
              </span>
            )}
            {Object.keys(seatModes).length > 0 && (
              <span style={{ marginLeft: '15px', color: '#6f42c1' }}>
                🛏️ Sleepers: {Object.keys(seatModes).length}
              </span>
            )}
            <button
              className="auto-number-btn"
              onClick={autoRenumberSeats}
              style={{ marginLeft: '15px', padding: '4px 12px', fontSize: '12px' }}
            >
              Auto-Number Seats
            </button>
          </div>
        </div>
      )}

      <div className="form-actions">
        <button className="modern-btn outline" onClick={() => setActiveTab('matrix')}>← Back</button>
        <button className="modern-btn primary" onClick={handleUpdateBus} disabled={isSubmitting}>
          {isSubmitting ? 'Updating...' : 'Update Bus'}
        </button>
      </div>
    </div>
  );

  return (
    <div className="modal-overlay modern" onClick={onClose}>
      <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header modern">
          <div className="header-content">
            <h2 className="modal-title">✏️ Edit Bus: {bus?.busNumber} ({bus?.busName})</h2>
            <p className="modal-subtitle">Update bus configuration</p>
          </div>
          <button className="modal-close-btn modern" onClick={onClose}>×</button>
        </div>
        <div className="modal-body modern">
          <ProgressSteps />
          {activeTab === 'basic' && renderBasicInfoTab()}
          {activeTab === 'route' && renderRouteTab()}
          {activeTab === 'matrix' && renderMatrixTab()}
          {activeTab === 'seats' && renderSeatLayoutTab()}
          {error && <div className="error-message modern">{error}</div>}
        </div>
      </div>
      {showLayoutModal && renderLayoutModal()}
      {showTemplateModal && renderTemplateModal()}
      {editingSeat && renderSeatEditModal()}
    </div>
  );
};

export default EditBusModal;